import { ReactNode } from "react";

interface FormSectionProps {
  title: string;
  description: string;
  children: ReactNode | ReactNode[];
}

export function FormSection({
  title,
  description,
  children,
}: FormSectionProps) {
  return (
    <div className="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-3">
      <div className="px-4 sm:px-0">
        <h2 className="text-base/7 font-semibold text-gray-900">{title}</h2>
        <p className="mt-1 text-sm/6 text-gray-600">{description}</p>
      </div>
      <div className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2 px-4 py-6 sm:p-8">
        {children}
      </div>
    </div>
  );
}
